var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-block home-block1" }, [
    _c(
      "h2",
      { staticClass: "home-block-title", attrs: { "data-aos": "fade-up" } },
      [_vm._v(" " + _vm._s(_vm.$t("home.block1.title")) + " ")]
    ),
    _c(
      "h3",
      { staticClass: "home-block-subtitle", attrs: { "data-aos": "fade-up" } },
      [_vm._v(" " + _vm._s(_vm.$t("home.block1.subtitle")) + " ")]
    ),
    _c(
      "div",
      { staticClass: "number-animate-block" },
      _vm._l(_vm.numbers, function (item) {
        return _c(
          "div",
          {
            key: item.ref,
            ref: item.ref,
            refInFor: true,
            staticClass: "number-item",
          },
          [
            _c("div", { staticClass: "number-animate-1" }, [
              _c(
                "div",
                { staticClass: "number-box" },
                [
                  _c("number", {
                    ref: item.numberRef,
                    refInFor: true,
                    staticClass: "number",
                    attrs: {
                      from: item.from,
                      to: item.to,
                      duration: 5,
                      delay: 0,
                      easing: "Power1.easeOut",
                      "animation-paused": true,
                    },
                  }),
                  _c("div", { staticClass: "unit" }, [
                    _vm._v(" " + _vm._s(item.unit) + " "),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "label" }, [
              _vm._v(" " + _vm._s(_vm.$t(item.label)) + " "),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }